<template>
  <v-btn @click="triggerFileInput" color="white" prepend-icon="mdi-upload">
    <span>{{ importMessage }}</span>
    <input type="file" ref="fileinput" @change="handleFileChange" style="display:none"/>
    <AlertDialog ref="alertDialog"/>
    <ConfirmDialog ref="confirmDialog"/>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';
import HTTP from '../plugins/backendAPI';
import AlertDialog from './AlertDialog.vue';
import ConfirmDialog from './ConfirmDialog.vue';

export default {
  components: { 
    AlertDialog,
    ConfirmDialog
  },
  props: ["tableType", "other", "importMessage", "workspaces"],
  computed: {
    ...mapGetters([
      "islegacy",
      "organizationitems",
      "workspaceid",
      "organizationid",
    ]),
  },
  data(){
    return {
        importFile: null,
        pendingImportFormData: null
    };
  },
  emits: ['postSuccess'],
  methods: {
    triggerFileInput(){
        this.$refs.fileinput.click();
    },
    handleFileChange(event){
        this.importFile = event.target.files[0];
        this.importExcel();
    },
    async importExcel(){
      this.$store.dispatch("setLoading", true);
        if (this.tableType == "all-inventories" || this.tableType == "inventory") {
            try {
                const formData = new FormData();
                formData.append('importFile', this.importFile);
                formData.append('workspaceId', this.workspaceid);
                formData.append('organizationId', this.organizationid);

                const fileVerificationResponse = await this.verifyImportFile(formData);

                if (fileVerificationResponse.data.userConfirmationRequired) {
                  this.pendingImportFormData = formData;
                  const confirmed = await this.$refs.confirmDialog.open('Confirm Import', fileVerificationResponse.data.message, {width: 600});

                  if (confirmed){
                    await this.processImportFile(this.pendingImportFormData);
                    this.pendingImportFormData = null; // Clear after processing
                  } else {
                    console.log('User cancelled the import.');
                    this.pendingImportFormData = null; // Clear if cancelled
                  }
                } else {
                  await this.processImportFile(formData);
                }
            } catch (error) {
                console.error('Upload failed:', error);
                await this.$refs.alertDialog.showDialog('Import Failed', error.response?.data || error.message, '$error');
             }finally {(() => {
          this.$store.dispatch("setLoading", false);
        })}
        } else {
            this.$store.dispatch("setLoading", false);
            throw new Error("Not a valid category for importing");
      }
    },
    async verifyImportFile(formData){
      return await HTTP.post(`/inventory/verifyImportFile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    async processImportFile(formData){
      console.log('File verification successful, proceeding with import.');

      const importResponse = await HTTP.post(`/inventory/importExcel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Upload successful!:', importResponse.data);
      this.$emit('postSuccess', importResponse.data);
      await this.$refs.alertDialog.showDialog('Import Successful', importResponse.data, '$success');
    }
  }
}

</script>